class PersistenceService {
    constructor(localStorageService) {
        this.ROOTKEY = "webcomm";
        this.USERKEY = "";
        this.USERPROFILEKEY = "";
        this.USERPROFILESERVERKEY = "";
        this.localStorageService = localStorageService;
        this.isSupported = this.localStorageService.isSupported;

        if (!localStorageService.isSupported)
            throw Error(`Local Storage as it's configured is not supported (${localStorageService.getStorageType})`); // https://github.com/grevory/angular-local-storage
    }

    updateUserInfo(username, profileId, server) {
        this.USERKEY = `${this.ROOTKEY}.${username}`;
        this.USERPROFILEKEY = `${this.USERKEY}.${profileId}`;
        this.USERPROFILESERVERKEY = `${this.USERPROFILEKEY}.${server}`;
    }

    setAppValue(key, value) { this._set(this.ROOTKEY, key, value); }
    setUserValue(key, value) { this._set(this.USERKEY, key, value); }
    setUserProfileValue(key, value) { this._set(this.USERPROFILEKEY, key, value); }
    setUserProfileServerValue(key, value) { this._set(this.USERPROFILESERVERKEY, key, value); }

    getAppValue(key) { return this._get(this.ROOTKEY, key); }
    getUserValue(key) { return this._get(this.USERKEY, key); }
    getUserProfileValue(key) { return this._get(this.USERPROFILEKEY, key); }
    getUserProfileServerValue(key) { return this._get(this.USERPROFILESERVERKEY, key); }

    evictAppValue(key) {  this._evict(this.ROOTKEY, key); }
    evictUserValue(key) {  this._evict(this.USERKEY, key); }
    evictUserProfileValue(key) {  this._evict(this.USERPROFILEKEY, key); }
    evictUserProfileServerValue(key) {  this._evict(this.USERPROFILESERVERKEY, key); }

    _set(level, key, value) {
        let newKey = `${level}.${key}`;

        if (this._checkKeyExists(newKey))
            this._keyException(newKey);

        this.localStorageService.set(newKey, value);
    }

    _get(level, key) { return this.localStorageService.get(`${level}.${key}`); }

    _evict(level, key) { this.localStorageService.remove(`${level}.${key}`); }

    _checkKeyExists(key) {
        return (key === this.USERKEY || key === this.USERPROFILEKEY || key === this.USERPROFILESERVERKEY);
    }

    _keyException(key) {
        throw `key '${key}' is reserved for internal use by the application`;
    }
}

angular.module('webcomm').service('persistenceService', ['localStorageService', PersistenceService]);